export default __webpack_public_path__ + "static/media/foxhome-logo.6ed98ed9.svg";